import { useNavigate } from "react-router-dom";
import { Navigation, NavigationWrapper, NavItem } from "./styles"

// import { GoHome } from 'react-icons/go';
import { AiOutlineCalendar } from 'react-icons/ai';
import { AiFillCalendar } from 'react-icons/ai';

import { GiMushroomGills, GiSuperMushroom } from 'react-icons/gi';

import { IoTicketOutline } from 'react-icons/io5';
import { IoTicket } from 'react-icons/io5';

import { RiUserSmileFill } from 'react-icons/ri'
import { RiUserSmileLine } from 'react-icons/ri'

const Nav = (props) => {
    const navigate = useNavigate();

    let { pathName } = props

    return (
        <NavigationWrapper>
            <svg width="0" height="0">
                <linearGradient id="blue-gradient" x1="100%" y1="100%" x2="0%" y2="0%">
                    <stop stopColor="#7a6ded" offset="0%" />
                    <stop stopColor="#591885" offset="100%" />
                </linearGradient>
            </svg>
            <svg width="0" height="0">
                <linearGradient id="orange-gradient" x1="100%" y1="100%" x2="0%" y2="0%">
                    <stop stopColor="#ee0979" offset="0%" />
                    <stop stopColor="#ff6a00" offset="100%" />
                </linearGradient>
            </svg>
            <svg width="0" height="0">
                <linearGradient id="pink-gradient" x1="100%" y1="100%" x2="0%" y2="0%">
                    <stop stopColor="#D66D75" offset="0%" />
                    <stop stopColor="#E29587" offset="100%" />
                </linearGradient>
            </svg>
            <svg width="0" height="0">
            <linearGradient id="gradient" x1="2%" y1="0%" x2="98%" y2="100%" >
                <stop offset="0%" stopColor="rgb(117,59,189)" stopOpacity="1.00" />
                <stop offset="50%" stopColor="rgb(240,78,152)" stopOpacity="1.00" />
                <stop offset="100%" stopColor="rgb(249,159,201)" stopOpacity="1.00" />
            </linearGradient>
            </svg>
            <Navigation>
                <NavItem onClick={() => navigate("/events", { replace: true })}>
                        {
                        pathName.startsWith('/events') ?
                        <>
                        <AiFillCalendar style={{ fill: "url(#gradient)" }}/>
                        <span style={{"fontSize": "0.5em", "fontWeight": "bold"}}>Eventos</span>
                        </>
                        :
                        <>
                        <AiOutlineCalendar style={{ fill: "gray" }}/>
                        <span style={{"fontSize": "0.5em"}}>Eventos</span>
                        </>
                        }
                </NavItem>
                <NavItem onClick={() => navigate("/wallet", { replace: true })}>
                        {
                        pathName.startsWith('/wallet') ?
                        <>
                        <IoTicket style={{ fill: "url(#gradient)" }}/>
                        <span style={{"fontSize": "0.5em", "fontWeight": "bold"}}>Ingressos</span>
                        </>
                        :
                        <>
                        <IoTicketOutline stroke="gray"/>
                        <span style={{"fontSize": "0.5em"}}>Ingressos</span>
                        </>
                        }
                </NavItem>
                <NavItem onClick={() => navigate("/user", { replace: true })}>
                    {
                        pathName.startsWith('/user') ?
                        <>
                        <GiSuperMushroom style={{ fill: "url(#gradient)" }}/>
                        <span style={{"fontSize": "0.5em", "fontWeight": "bold"}}>Perfil</span>
                        </>
                        :
                        <>
                        <GiSuperMushroom style={{ fill: "gray" }}/>
                        <span style={{"fontSize": "0.5em"}}>Perfil</span>
                        </>
                        }
                </NavItem>
            </Navigation>
        </NavigationWrapper>
    )
}

export default Nav;